export const INITIAL_FORM_DATA = {
  name: '',
  dateOfIncident: '',
  position: '',
  department: '',
  supervisor: '',
  dateOfHire: '2024-01-01',
  policyViolationIds: [],
  descriptionOfFeedback: '',
  immediateFeedback: '',
  expectationForImprovement: '',
  emailOfFeedback: '',
};
